<template>
  <v-row v-if="documents.length > 0">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <v-col
      cols="12"
    >
      <v-list subheader>
        <v-subheader>{{ $t('custom.files') }}</v-subheader>

        <v-list-item
          v-for="item in documents"
          :key="item.id"
        >
          <v-list-item-avatar tile>
            <v-img
              v-if="item.document_type && item.document_type.includes('image')"
              :alt="item.original_name ? item.original_name : item.id"
              :src="item.presigned_url || item.url"
              @click="screenFullImage(item)"
              style="cursor: pointer;"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-icon
              v-else
              color="grey"
              @click="screenFullImage(item)"
            >
              mdi-file
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-if="edit_filename_id != item.id" @click="edit_filename_id = item.id" style="cursor: pointer;">
              {{ item.original_name ? item.original_name : item.id }}
            </v-list-item-title>
            <v-text-field
              v-else
              v-model="item.original_name"
              @keyup.enter="updateFileInfo(item)"
              @blur="updateFileInfo(item)"
              :loading="isLoadingUpdateFileInfo"
              autofocus
            ></v-text-field>
          </v-list-item-content>

          <v-list-item-icon>
            <v-btn icon @click="downloadItem(item.id)" color="success" :loading="isLoadingClientsFileDownload">
              <v-icon>
                mdi-content-save-outline
              </v-icon>
            </v-btn>
            <v-menu absolute offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="pink" :disabled="(isLoadingRecognizeDocument && selected_file == item) || !getMimeType(item)" :loading="isLoadingRecognizeDocument && selected_file == item">
                  <v-icon>
                    mdi-robot-outline
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item link v-for="(model, index) in recognize_document_models" :key="index" @click="startRecognizeDocument(item, model.value), selected_file = item" color="pink">
                  <v-list-item-title>
                    {{ model.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn icon @click="deleteItem(item)" color="error">
              <v-icon>
                mdi-delete-forever
              </v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-col>
    <v-dialog v-model="dialog" :retain-focus="false" max-width="800">
      <v-card class="mt-2">
        <v-card-text>
          <v-img :src="link_full_image" contain class="grey lighten-2"> </v-img>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="(dialog = false), (link_full_image = '')"
          >
            {{ $t('custom.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000" multi-line>
      <div>
        <div class="text-subtitle-1 font-weight-bold">{{ snackbar.title }}</div>
        <div v-if="snackbar.text" class="text-body-2">{{ snackbar.text }}</div>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          {{ $t('custom.close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>
<script>
import { saveAs } from "file-saver";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import moment from "moment";
export default {
  props: {
    documents: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      // documents: [],
      gallery_items: [],
      link_full_image: "",
      edit_filename_id: null,
      dialog: false,
      iam_yandex_token: null,
      selected_file: null,
      recognize_document_models: [
        {text: this.$t('yandex_cloud.passport'), value: "passport"},
        {text: this.$t('yandex_cloud.driver_license_front'), value: "driver-license-front"},
        {text: this.$t('yandex_cloud.driver_license_back'), value: "driver-license-back"}
      ],
      isLoadingUpdateFileInfo: false,
      isLoadingRecognizeDocument: false,
      isLoadingClientsFileDownload: false,
      isLoading: false,
      snackbar: {
        show: false,
        color: 'success',
        title: '',
        text: ''
      }
    };
  },
  computed: {
    user_role() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.role
      } else {
        return ""
      }
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },

  },
  methods: {
    screenFullImage(item) {
      this.link_full_image = item.presigned_url;
      this.dialog = true;
    },
    includedInPlan(service) {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan) {
          if (this.$store.getters.getMainCompany.plan.included_services) {
            // check trial period
            if (this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            }
            return this.$store.getters.getMainCompany.plan.included_services.includes(service);
          }
        }
      }
      return false;
    },
    downloadItem(id) {
      this.isLoadingClientsFileDownload = true;
      this.axios
        .get(`/api/v1/clients_files/download/${id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken
          }
        })
        .then((response) => {
          let presigned_url = response.data.presigned_url
          if (!this.isNative) {
            saveAs(presigned_url);
          } else {
            this.downloadFileToMobile(presigned_url)
          }
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.file_client_load'))
        })
        .finally(() => (this.isLoadingClientsFileDownload = false))
    },
    downloadFileToMobile(item_url) {
      if (Filesystem.checkPermissions()) {
        // Сначала получаем Blob из URL
        fetch(item_url)
          .then(response => response.blob())
          .then(blob => {
            // Теперь у нас есть настоящий Blob объект
            const getBase64FromBlob = async (blob) => {
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;
                  resolve(base64data);
                }
              });
            }

            return getBase64FromBlob(blob);
          })
          .then((base64) => {
            // Определяем расширение файла
            let fileExtension = '';

            // Пытаемся получить расширение из URL
            const urlExtMatch = item_url.match(/\.([^./?#]+)($|\?|#)/);
            if (urlExtMatch) {
              fileExtension = `.${urlExtMatch[1].toLowerCase()}`;
            }
            // Если не удалось получить из URL, пытаемся определить из MIME-типа в base64
            else if (base64.startsWith('data:')) {
              const mimeMatch = base64.match(/^data:([^;]+);/);
              if (mimeMatch) {
                const mimeType = mimeMatch[1].toLowerCase();
                if (mimeType.startsWith('image/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                } else if (mimeType === 'application/pdf') {
                  fileExtension = '.pdf';
                } else if (mimeType.startsWith('video/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                } else if (mimeType.startsWith('audio/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                }
              }
            }

            // save file
            async function writeFile() {
              return await Filesystem.writeFile({
                path: `photo_${Date.now()}_${Math.floor(Math.random() * 1000)}${fileExtension}`,
                data: base64,
                directory: Directory.Documents,
              });
            };

            writeFile().then((getUriResult) => {
              // share file opened file
              let shareFile = async () => {
                await Share.share({
                  title: 'Download document',
                  files: [getUriResult.uri],
                }).catch((error) => {
                  console.log("shareFile", error)
                });
              };

              shareFile();
            }).catch((error) => {
              console.log("shareFile", error)
            });
          })
          .catch(error => {
            console.log("Error getting base64:", error);
          });
      } else {
        Filesystem.requestPermissions();
      }
    },
    updateFileInfo(item) {
      if (this.user_role != "guest" && this.user_role != "partner") {
        if (!item.original_name || item.original_name.trim() === "") {
          return;
        }
        this.isLoadingUpdateFileInfo = true;
        this.axios
          .patch(`/api/v1/clients_files/${item.id}`, {
            clients_files: {
              original_name: item.original_name.trim()
            }
          }, {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          })
          .then(() => {
            this.edit_filename_id = null;
          })
          .catch(error => {
            this.setError(error, this.$t('errors.error'));
          })
          .finally(() => (this.isLoadingUpdateFileInfo = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async deleteItem(item) {
       if (this.user_role != "guest" && this.user_role != "partner") {
        let self = this
        this.$swal({
          title: this.$t('custom.you_sure_title'),
          text: this.$t('custom.you_sure_text'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('custom.you_sure_yes'),
          cancelButtonText: this.$t('custom.you_sure_no'),
          showCloseButton: true
        }).then(result => {
          if (result.value) {
            this.isLoading = true;
            this.axios
              .delete(`/api/v1/clients_files/${item.id}`, {
                headers: {
                  Authorization: self.$store.getters.getAuthToken
                }
              })
              .then(() => {
                this.documents.splice(this.documents.indexOf(item), 1);
                this.$swal({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 2000,
                  icon: "success",
                  title: this.$t('custom.deleted'),
                  text: this.$t('other.delete_file')
                });
              })
              .catch(error => {
                this.setError(error, this.$t('errors.file_client_load'));
              })
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    getMimeType(file) {
      let mime_type = 'image'
      if(file.document_type) {
        mime_type = file.document_type
      }
      if(mime_type.startsWith('image/')) {
        return 'image'
      }
      return mime_type
    },
    startRecognizeDocument(file, model) {
      if (this.includedInPlan("yandex_cloud_recognize_document")) {
        this.recognizeDocumentInYandexCloud(file, model)
      } else {
        this.$notify(this.$t('yandex_cloud.recognize_document_not_included'), '', 'warning')
      }
    },
    recognizeDocumentInYandexCloud(file, model) {
      this.isLoadingRecognizeDocument = true
      // passport, driver-license-front, driver-license-back, vehicle-registration-front и vehicle-registration-back
      this.axios.post("/api/v1/yandex_cloud/recognize_text", {
          client_id: file.client_id,
          url: file.presigned_url,
          mimeType: this.getMimeType(file),
          languageCodes: ["*"],
          model: model
        }, {
          headers: {
            Authorization: this.$store.getters.getAuthToken
          }
        })
        .then((response) => {
          if (response.data.result) {
            let result = response.data.result.result
            let entities = result.textAnnotation.entities
            let passport_data = {}
            entities.forEach(entity => {
              passport_data[entity.name] = entity.text
            })
            this.$emit('updateClientFromRecognizeDocument', passport_data, model)
            this.$notify(this.$t('yandex_cloud.document_recognized'), '', 'success')
          } else {
            this.$notify(this.$t('yandex_cloud.file_not_recognized'), '', 'error')
          }
        })
        .catch((error) => {
          console.log(error.response.data)
          if (error.response.status == 406) {
            this.$notify(this.$t('yandex_cloud.file_not_recognized'), error.response.data.error, 'error')
          } else {
            this.setError(error, this.$t('errors.error'))
          }
        })
        .finally(() => (this.isLoadingRecognizeDocument = false))
    },
    async imageToBase64(image_url) {
      const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
          }
        });
      }
      return getBase64FromUrl(image_url)
    },
    setError(error, text) {
      this.$rollbar.configure({
        payload: {
          person: {
            id: this.$store.getters.getCurrentUser ? this.$store.getters.getCurrentUser.id : null,
            username: this.$store.getters.getCurrentUser.name ? this.$store.getters.getCurrentUser.name : null,
            email: this.$store.getters.getCurrentUser ? this.$store.getters.getCurrentUser.email : null,
          },
          custom: {
            company: this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.name ? this.$store.getters.getCompany.company.name : null,
          }
        }
      });
      this.$rollbar.error(text, error);
      this.$notify(this.$t("errors.error"), `${error}. ${text}`, "error", 5000);
      console.log(error);
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    }
  }
};
</script>
